import { render, staticRenderFns } from "./ShopCart.vue?vue&type=template&id=1529084f&scoped=true"
import script from "./ShopCart.vue?vue&type=script&lang=js"
export * from "./ShopCart.vue?vue&type=script&lang=js"
import style0 from "./ShopCart.vue?vue&type=style&index=0&id=1529084f&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1529084f",
  null
  
)

export default component.exports